import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { useForm } from 'react-hook-form';
import UpdateConfirmDialog from './UpdateConfirmDialog';
import DialogTitle from '@material-ui/core/DialogTitle';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

/**
 * Function to modificate the pricing plans
 * @param {*} props
 * @returns
 */
function UpdateCourseDialog(props) {
  const {
    openStatus, onClosed, rowData, schoolYear
  } = props;
  /**
  * Status confirm screen
  */
  const [statusConfirm, setStatusConfirm] = React.useState(false);
  const [modifiedData, setModifiedData] = React.useState({});
  const [schoolYearId, setSchoolYearId] = useState('');
  const [helperTextType, setHelperTextType] = React.useState();
  const [errorType, setErrorType] = React.useState(false);
  /**
  * Status helper text
  */
  const [helpertext, setHelperText] = React.useState();
  const [error, setError] = React.useState(false);
  const { register, handleSubmit, errors } = useForm();

  const handleCloseConfirm = () => {
    setStatusConfirm(false);
  };

  /**
   * Method to add the register and create que request
   * @param {*} formData
   */
  const onSubmit = async(formData) => {
    if (schoolYearId === "") {
      // validate the required field role type
        setHelperTextType("Valor requerido");
        setErrorType(true);
    } else {  
      const requestBody = {
          id:rowData[0],
          name: formData.name,
          description: formData.description, 
          school_year_id: ""+schoolYearId.id+"",
          status: rowData[5]
        };
        setModifiedData(requestBody);
        setHelperText('');
        setError(false);
        onClosed();
        setStatusConfirm(true);
      }
    };

  /**
   * Method to recover the period type list and atribute list
   * @param {data} data
   */
  useEffect(() => {
    if (openStatus) {
      schoolYear.map((option) => {
        if (option.id === rowData[4]) {
          setSchoolYearId(option);
        }
      });
    }
  }, [openStatus]);

    /**
   * Method to control the combobox of role type
   */
    const handleChangeType = (event) => {
      setSchoolYearId(event.target.value);
    };

  /**
   * Method to close the dialog
   */
  const handleCloseAction = () => {
    setHelperText('');
    setError(false);
    onClosed();
  };


  return (
    <div>
    <Grid container justifyContent="center" direction="column">
      <Dialog
        fullWidth
        maxWidth="sm"
        open={openStatus}
        onClose={handleCloseAction}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Añadir</DialogTitle>
        <DialogContent>
          <form noValidate onSubmit={handleSubmit(onSubmit)} id = "modifyForm">
            <div >
                <TextField
                required
                name="name"
                autoFocus
                margin="dense"
                id="name"
                defaultValue={rowData[1]}
                inputRef={register({
                  required: "El campo es requerido",
                })}
                error={!!errors.name} helperText={errors.name ? errors.name.message : ''}
                label="Nombre"
                type="text"
                width="90%"
              />
               <TextField
                required
                name="description"
                autoFocus
                margin="dense"
                multiline
                id="description"
                rows={4}
                defaultValue={rowData[2]}
                inputRef={register({
                  required: "El campo es requerido",
                })}
                error={!!errors.description} helperText={errors.description ? errors.description.message : ''}
                label="Descripción"
                type="text"                
                style={{marginLeft:"120px"}}
              />
              <br/>
                <FormControl width="90%" >
                  <InputLabel required error={errorType} htmlFor="status-helper">Periodo:</InputLabel>
                  <Select
                    name="period"
                    labelId="demo-checkbox-label"
                    id="period"
                    fullWidth
                    value={schoolYearId}
                    onChange={handleChangeType}
                    input={<Input />}
                    MenuProps={MenuProps}
                    style={{width:"200px"}}
                  >
                    <MenuItem name="" value="">
                      Ninguno
                    </MenuItem>
                    {schoolYear.map((value, key) => (
                      <MenuItem name={value} key={key.toString()} value={value}>
                         {value.year}
                      </MenuItem>
                    ))}
                  </Select>
                  {errorType && <FormHelperText error>{helperTextType}</FormHelperText>}
                </FormControl>
              <TextField
                required
                name="status"
                disabled
                margin="dense"
                id="status"
                defaultValue={rowData[5]}
                inputRef={register({
                  required: "El campo es requerido",
                })}
                error={!!errors.status} helperText={errors.status ? errors.status.message : ''}
                label="Estado"
                type="text"
                fullWidth
              />
              
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          <Button id="button_close" onClick={handleCloseAction}>Cerrar</Button>
          <Button id="button_agree_modify_course" variant="contained" style={{backgroundColor: "#68dcb9", color: "#FFFFFF"}} type="submit" form="modifyForm">
            Modificar
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
     <UpdateConfirmDialog openStatusConfirm={statusConfirm} onClosedConfirm={handleCloseConfirm} rowData={modifiedData}/>
     </div>
  );
}

UpdateCourseDialog.propTypes = {
  /** Status of modify dialog */
  openStatus: PropTypes.bool.isRequired,
  /** Function of modify dialog */
  onClosed: PropTypes.func.isRequired,
  /** Array of pricing plan */
  rowData: PropTypes.array.isRequired,
  /** Array of pricing plan */
  schoolYear: PropTypes.array.isRequired

};

export default UpdateCourseDialog;
